module.exports = __webpack_public_path__ + "img/toupiaoguanjia_new.8a363f07.png";